(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["park-browse"] && !Shopify.designMode) return;
  try {
    (function(){
function initParkBrowse(){
var home=document.getElementById('pn-home-parks');
if(home){var hero=document.querySelector('#MainContent .index-sections > .shopify-section');if(hero)hero.after(home);}
var directory=document.querySelector('.pn-directory');
if(directory){var controls=directory.querySelector('.pn-directory-controls');controls.hidden=false;var input=document.getElementById('pn-park-search');var region=document.getElementById('pn-park-region');var cards=Array.from(directory.querySelectorAll('.pn-park-card'));var count=document.getElementById('pn-park-count');var empty=document.getElementById('pn-park-empty');var normal=function(s){return s.normalize('NFD').replace(/[̀-ͯ]/g,'').toLowerCase().replace(/[ʻ’']/g,'');};var filter=function(){var term=normal(input.value.trim());var shown=0;cards.forEach(function(card){var match=normal(card.dataset.parkName).includes(term)&&(!region.value||card.dataset.parkRegion===region.value);card.hidden=!match;if(match)shown++;});count.textContent=shown;empty.hidden=shown>0;};input.addEventListener('input',filter);region.addEventListener('change',filter);}
var chips=document.querySelectorAll('.pn-category-links a');chips.forEach(function(chip){if(chip.pathname.toLowerCase()===window.location.pathname.toLowerCase())chip.setAttribute('aria-current','page');});
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',initParkBrowse);}else{initParkBrowse();}
})();
  } catch(e) { console.error(e); }
})();

})();
